<template>
  <div class="container">
    <div class="row mt-1 d-flex align-items-center">
      <div class="col padding2">
        <button
          class="btn btn-sm btn-primary padding2"
          @click="toggleOptions()"
        >
          {{ store.org_name }}
        </button>
      </div>
      <div class="col-6 text-center">
        <div class="d-flex justify-content-between">
          <input
            type="date"
            id="start_dateInput"
            class="form-control date-field me2"
            placeholder="Date"
            :value="store.start_date"
            @change="updateDate('start')"
          />
          <input
            type="date"
            id="end_dateInput"
            class="form-control date-field me2"
            placeholder="Date"
            :value="store.end_date"
            @change="updateDate('end')"
          />
        </div>
      </div>
      <div class="col">
        <i class="bi bi-x-lg text-danger float-end" @click="clearOrg()"></i>
      </div>
    </div>
    <div class="row" v-if="options">
      <div class="col d-flex justify-content-around">
        <i
          class="bi bi-journal-text"
          @click="store.setAction('addaccount')"
        ></i>
        <i class="bi bi-pen" @click="store.setAction('editaccount')"></i>
        <i class="bi bi-gear" @click="store.setAction('attendanceaccount')"></i>
      </div>
    </div>
    <div class="row">
      <OrgActions></OrgActions>
    </div>
    <div class="row mt-2" v-if="store.action == 'attendanceaccount'">
      <AttendanceAccount></AttendanceAccount>
    </div>
    <div class="row mt-2" v-if="store.action == 'attendance'">
      <AttendancePage></AttendancePage>
    </div>
    <div class="row mt-2" v-if="store.action == 'addaccount'">
      <AddAccount></AddAccount>
    </div>
    <div class="row mt-2" v-if="store.action == 'editaccount'">
      <EditAccount></EditAccount>
    </div>
    <div class="row mt-2" v-if="store.action == 'transact'">
      <AccountEntry></AccountEntry>
    </div>
    <div class="row mt-2" v-if="store.action == 'note'">
      <NewNote></NewNote>
    </div>
    <div class="row mt-2">
      <JournalEntries></JournalEntries>
    </div>
  </div>
</template>
<script setup>
import { useStore } from "../../store/index";
import { auth, db } from "../../firebase/config";
import {
  doc,
  updateDoc,
  collection,
  query,
  where,
  onSnapshot,
} from "firebase/firestore";
import { ref, onMounted, onBeforeUnmount, watchEffect } from "vue";
import OrgActions from "./OrgActions.vue";
import AddAccount from "../account/AddAccount.vue";
import EditAccount from "../account/EditAccount.vue";
import AccountEntry from "../account/AccountEntry.vue";
import AttendanceAccount from "../account/AttendanceAccount.vue";
import JournalEntries from "../journal/JournalEntries.vue";
import AttendancePage from "../attendance/AttendancePage.vue";
import NewNote from "../note/NewNote.vue";
const store = useStore();
var unsubscribe;
const options = ref(false);

const toggleOptions = () => {
  options.value = !options.value;
  if (store.action) {
    store.setAction("");
  }
};
const clearOrg = async () => {
  const userRef = doc(db, "users", auth.currentUser.uid);
  await updateDoc(userRef, {
    "settings.active_org": "",
    "settings.org_name": "",
    "settings.active_account": "",
    "settings.start_date": "",
    "settings.end_date": "",
    "settings.action": "",
  });
};
onBeforeUnmount(() => {
  unsubscribe();
});
onMounted(() => {
  const q = query(
    collection(db, "accounts"),
    where("org", "==", store.active_org)
  );
  unsubscribe = onSnapshot(q, (querySnapshot) => {
    const cities = [];
    querySnapshot.forEach((docy) => {
      cities.push({ id: docy.id, ...docy.data() });
    });
    store.setAccounts(cities);
  });
});

const updateDate = async (choice) => {
  const userRef = doc(db, "users", auth.currentUser.uid);
  if (choice == "start") {
    await updateDoc(userRef, {
      "settings.start_date": document
        .getElementById("start_dateInput")
        .value.trim(),
    });
  }
  if (choice == "end") {
    await updateDoc(userRef, {
      "settings.end_date": document
        .getElementById("end_dateInput")
        .value.trim(),
    });
  }
};
</script>
<style scoped>
.padding2 {
  padding: 2px;
}
.date-field {
  width: auto;
  min-width: 125px; /* Ensures a reasonable default width */
  padding: 0.1rem 0.1rem; /* Matches default form-control padding */
  box-sizing: border-box; /* Ensures padding doesn't affect width */
}
</style>
